import http from './api/http'

const UPLOAD_ENDPOINT = '/api/assets'

class Client {
  constructor ({host}) {
    this.host = host
    this.axios = http.getAxiosInstance(host)
  }

  setToken (token) {
    this.axios.defaults.headers['APIKEY'] = token
  }

  async post ({data, config}) {
    if (config === null || typeof config === 'undefined') {
      config = {}
    }
    let defaultConfig = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    config = Object.assign(defaultConfig, config)
    console.log('config > ', config)
    return this.axios.post(UPLOAD_ENDPOINT, data, config)
  }

  async delete (id) {
    return this.axios.delete(UPLOAD_ENDPOINT + '/' + id)
  }
}

const install = function (Vue, options) {
  const fus = new Client(options)
  Vue.prototype.$fus = fus
  Vue.$fus = fus
}

export default {
  Client, install
}



// WEBPACK FOOTER //
// ./src/services/FileUploadService.js